import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Query } from "react-apollo";
import { AUTH_TOKEN, USER_ID } from "../constants";
import mln from "../static/mln-logo-transparent.png"; // Tell Webpack this JS file uses this image
import { PROFILE_QUERY } from "./Account";

class Header extends Component {
  logout() {
    localStorage.removeItem(AUTH_TOKEN);
    localStorage.removeItem(USER_ID);
    window.location.href = "/";
  }

  render() {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    return (
      <div className="top-bar flex flex-wrap pa1 pr2 justify-between nowrap">
        <div className="flex sm-flex-wrap sm-w-100">
          <div className="logo flex items-center justify-between">
            <Link to="/" className="ml1 no-underline flex items-center">
              <img src={mln} alt="mlnews logo" />
              <div className="fw7 mr1 dib">ML News</div>
            </Link>
            {authToken ? (
              <Link
                to={`/account/${localStorage.getItem(USER_ID)}`}
                className="no-underline link sm-down dib sg_username-header"
              >
                <Query
                  query={PROFILE_QUERY}
                  variables={{ userId: localStorage.getItem(USER_ID) }}
                >
                  {({ loading, error, data }) => {
                    if (loading || error || !data) return "";
                    return (
                      <span>
                        {data.profile.name} (
                        {data.profile.links.reduce((acc, link) => {
                          return acc + link.votes.length;
                        }, 0)}
                        )
                      </span>
                    );
                  }}
                </Query>
              </Link>
            ) : (
              <Link
                to="/login"
                className="mr1 no-underline link sm-down sg_login"
              >
                login
              </Link>
            )}
          </div>
          <div className="nav flex items-center w-100">
            <Link to="/new/1" className="ml1 no-underline  link">
              new
            </Link>
            <div className="ml1">|</div>
            <Link to="/search" className="ml1 no-underline link">
              search
            </Link>
            {authToken && (
              <Fragment>
                <div className="ml1">|</div>
                <Link to="/create" className="ml1 no-underline link">
                  submit
                </Link>
                <div
                  className="pointer link sm-down mla sg_logout"
                  onClick={() => {
                    this.logout();
                  }}
                >
                  logout
                </div>
              </Fragment>
            )}
          </div>
        </div>
        <div className="flex sm-w-100 items-center">
          {authToken ? (
            <Fragment>
              <Link
                to={`/account/${localStorage.getItem(USER_ID)}`}
                className="no-underline link sm-up sg_username-header"
              >
                <Query
                  query={PROFILE_QUERY}
                  variables={{ userId: localStorage.getItem(USER_ID) }}
                >
                  {({ loading, error, data }) => {
                    if (loading || error || !data) return "";
                    return (
                      <div>
                        {data.profile.name} (
                        {data.profile.links.reduce((acc, link) => {
                          return acc + link.votes.length;
                        }, 0)}
                        )
                      </div>
                    );
                  }}
                </Query>
              </Link>
              <div className="ml1 sm-up">|</div>
              <div
                className="ml1 pointer link sm-up sg_logout"
                onClick={() => {
                  this.logout();
                }}
              >
                logout
              </div>
            </Fragment>
          ) : (
            <Link to="/login" className="ml1 no-underline link sm-up sg_login">
              login
            </Link>
          )}
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js